export default __webpack_public_path__ + "958c38edd5595992c3f7419f9685f37e.woff2";